// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__epDHF","col":"styles_col__339Ob","actions":"styles_actions__3wOFU","conflict":"styles_conflict__2E6T4"};